import { memo } from 'react';

import {
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
  Tooltip
} from '@/shadcn/tooltip';
import { X } from 'lucide-react';
import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';

type Props = {
  index: number;
  value: string;
  removeValue: (index: number) => void;
};

/**
 * A single value element in the multiple values text area
 */
export const ValueLabel = memo(({ index, value, removeValue }: Props) => {
  return (
    <div className="text-accent-foreground bg-accent m-1 flex flex-row flex-nowrap items-center gap-2 rounded-md py-0.5 pr-1 pl-2 text-sm">
      {value}

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="smallIcon"
              className="hover:brightness-90"
              onClick={() => removeValue(index)}
              data-testid={TestId.ValueLabel.RemoveButton}
            >
              <X size={15} />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Remove email</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
});
